import styled from 'styled-components'

import { Card as DefaultCard } from '@/components/business/visitor-parking/card'
import { Icon as DefaultIcon } from '@/components/ui/icon'

export const Title = styled.h1(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '3.6rem',
  fontWeight: 600,
  marginBottom: theme.space['40'],
  textAlign: 'center',
}))

export const Card = styled(DefaultCard)({
  alignItems: 'center',
  justifyContent: 'center',
})

export const Icon = styled(DefaultIcon)(({ theme }) => ({
  color: theme.colors.visitorParkingErrorText,
  marginBottom: theme.space['10'],
}))

export const ErrorInfo = styled.p(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '2rem',
  fontWeight: 600,
  textAlign: 'center',
}))

export const ErrorDescription = styled.p(({ theme }) => ({
  color: theme.colors.black700,
  fontSize: '1.4rem',
  fontWeight: 400,
  textAlign: 'center',
}))
